import { onAuthStateChanged, signInWithCustomToken } from '@firebase/auth';
import type { Auth, User } from '@firebase/auth';

import { auth, ensureFirebaseAuth } from './firebase';

export const getUser = (): User | undefined => (auth ? (auth.currentUser ?? undefined) : undefined);

const waitForAuthState = (authInstance: Auth): Promise<void> =>
	new Promise((resolve) => {
		const unsubscribe = onAuthStateChanged(authInstance, () => {
			unsubscribe();
			resolve();
		});
	});

export const loginWithToken = async (tokenPromise: Promise<string>): Promise<string> => {
	const token = await tokenPromise;

	const authInstance = await ensureFirebaseAuth();

	const userCredential = await signInWithCustomToken(authInstance, token);

	return userCredential.user.getIdToken();
};

export const forceRefreshToken = async (): Promise<void> => {
	const authInstance = await ensureFirebaseAuth();

	await waitForAuthState(authInstance);

	const user = getUser();

	if (!user) {
		throw new Error('No user found');
	}

	await user.getIdToken(true);
};

export const logout = async (): Promise<void> => {
	if (!auth) {
		return;
	}

	await auth.signOut();
};
